import { target, targets, targetable } from '@github/catalyst/lib/targetable'

export default targetable(class extends HTMLElement {
  static [target.static] = ['moreTrigger', 'moreLabel', 'moreDropdown', 'tabsRow']
  static [targets.static] = ['tabs', 'panels']

  connectedCallback () {
    this.addEventListener('click', this.onClick)
    this.setLang(this.dataset.visibleLang || 'node_fetch')

    if (this.tabsRow && this.moreDropdown) {
      this.updateTabsOverflow()

      this.resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.tabsOverflowFrame)
        this.tabsOverflowFrame = requestAnimationFrame(this.updateTabsOverflow)
      })
      this.resizeObserver.observe(this)
    }
  }

  disconnectedCallback () {
    cancelAnimationFrame(this.tabsOverflowFrame)
    this.resizeObserver?.disconnect()
  }

  onClick = (e) => {
    const button = e.target.closest('[data-lang-btn]')

    if (!button) return

    this.setLang(button.dataset.langBtn)

    document.activeElement?.blur()
  }

  setLang (lang) {
    const panel = this.panels.find((el) => {
      const codeLang = el.querySelector('code').dataset.lang

      return codeLang === lang || codeLang.startsWith(`${lang}_`)
    })

    if (!panel) return

    const codeEl = panel.querySelector('code')

    this.panels.forEach((el) => el.classList.toggle('hidden', el !== panel))

    if (codeEl.dataset.html && !codeEl.innerHTML) {
      codeEl.innerHTML = codeEl.dataset.html
    }

    this.clipboard.dataset.text = codeEl.textContent

    this.tabs.forEach((el) => el.toggleAttribute('data-active', el.dataset.langBtn === codeEl.dataset.lang))

    this.updateMoreTrigger()
  }

  updateTabsOverflow = () => {
    const rowTabs = this.tabs.filter((el) => this.tabsRow.contains(el))

    if (!rowTabs.length) return

    rowTabs.forEach((el) => el.classList.remove('hidden'))
    this.moreDropdown.classList.add('hidden')

    const hiddenLangs = []

    if (this.tabsRow.scrollWidth > this.tabsRow.clientWidth + 1) {
      this.moreDropdown.classList.remove('hidden')

      const budget = this.tabsRow.parentElement.getBoundingClientRect().width - this.moreDropdown.getBoundingClientRect().width
      let used = 0

      rowTabs.forEach((el) => {
        used += el.getBoundingClientRect().width

        if (used > budget + 0.5) {
          el.classList.add('hidden')
          hiddenLangs.push(el.dataset.langBtn)
        }
      })
    }

    this.moreDropdown.querySelectorAll('[data-lang-item]').forEach((el) => {
      el.classList.toggle('hidden', !hiddenLangs.includes(el.dataset.langItem))
    })

    this.updateMoreTrigger()
  }

  updateMoreTrigger () {
    if (!this.moreTrigger) return

    const dropdown = this.moreDropdown || this.moreTrigger.parentElement
    const activeTab = this.tabs.find((el) => el.hasAttribute('data-active'))
    const activeRowTab = this.tabs.find((el) => el.hasAttribute('data-active') && !dropdown.contains(el))
    const activeInMore = !!activeTab && (!activeRowTab || activeRowTab.classList.contains('hidden'))

    this.moreTrigger.toggleAttribute('data-active', activeInMore)
    this.moreLabel.textContent = activeInMore ? activeTab.textContent.trim() : 'More'
  }

  get clipboard () {
    return this.querySelector('clipboard-copy')
  }
})
